<template>
  <div class="public-hearing-page">

    <!-- Carregando -->
    <div v-if="loading" class="text-center py-5">
      <div class="spinner-border text-success" style="width:3rem;height:3rem;" role="status"></div>
      <p class="mt-3 text-muted">Carregando evento...</p>
    </div>

    <!-- Não encontrado -->
    <div v-else-if="!evento" class="d-flex justify-content-center align-items-center" style="min-height:80vh">
      <div class="card text-center" style="max-width:480px;width:100%">
        <div class="card-body py-5 px-4">
          <i class="fa fa-times-circle fa-3x text-danger mb-3 d-block"></i>
          <h4>Evento não encontrado</h4>
          <p class="text-muted">Este link não é válido ou o evento foi encerrado.</p>
        </div>
      </div>
    </div>

    <!-- Conteúdo -->
    <div v-else class="public-hearing-container mx-auto py-4 px-3">

      <!-- Cabeçalho do evento -->
      <div class="card mb-4 border-0 shadow-sm overflow-hidden">
        <div class="public-hearing-header text-white text-center py-4 px-3">
          <div class="mb-2">
            <i class="fa fa-tree fa-2x"></i>
          </div>
          <h3 class="mb-1 font-weight-bold">{{ evento.title }}</h3>
          <p class="mb-1 opacity-75">
            <i class="fa fa-calendar mr-1"></i>{{ formatarData(evento.event_date) }}
          </p>
          <p class="mb-0 opacity-75">
            <i class="fa fa-map-marker mr-1"></i>{{ evento.location }}
          </p>
        </div>
      </div>

      <!-- Não é o dia do evento -->
      <div v-if="!isHojeEvento" class="card shadow-sm mb-4">
        <div class="card-body text-center py-5 px-4">
          <i class="fa fa-clock-o fa-3x text-warning mb-3 d-block"></i>
          <h5 class="mb-2">Confirmação ainda não disponível</h5>
          <p class="text-muted mb-1">A confirmação de presença estará disponível somente no dia do evento:</p>
          <p class="font-weight-bold mb-4">{{ formatarDataSimples(evento.event_date) }}</p>
          <router-link :to="'/audiencia-publica/' + token" class="btn btn-outline-success btn-sm">
            <i class="fa fa-arrow-left mr-1"></i> Voltar para inscrição
          </router-link>
        </div>
      </div>

      <!-- É o dia do evento: formulário de confirmação -->
      <div v-else class="card shadow-sm mb-4">
        <div class="card-header bg-light">
          <strong><i class="fa fa-id-card mr-2"></i>Confirmar Presença</strong>
        </div>

        <!-- Sucesso -->
        <div v-if="confirmacaoFeita" class="card-body text-center py-5">
          <template v-if="confirmacaoJaFeita">
            <i class="fa fa-info-circle fa-3x text-info mb-3 d-block"></i>
            <h5>Presença já confirmada!</h5>
            <p class="text-muted mb-0">
              <strong>{{ confirmacaoDados.full_name }}</strong>, sua presença já foi registrada.
            </p>
          </template>
          <template v-else>
            <i class="fa fa-check-circle fa-3x text-success mb-3 d-block"></i>
            <h5>Presença confirmada!</h5>
            <p class="text-muted mb-0">
              Bem-vindo(a), <strong>{{ confirmacaoDados.full_name }}</strong>!
            </p>
          </template>
        </div>

        <!-- Formulário -->
        <div v-else class="card-body">
          <p class="text-muted small mb-3">
            Digite o nome, e-mail ou telefone informado no momento da inscrição.
          </p>
          <div class="form-group mb-2">
            <input
              v-model="identificador"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': erroConfirmacao }"
              placeholder="Nome, e-mail ou telefone"
              @keyup.enter="confirmarPresenca"
            />
            <div v-if="erroConfirmacao" class="invalid-feedback d-block">{{ erroConfirmacao }}</div>
          </div>
          <button
            class="btn btn-success btn-block"
            :disabled="enviandoConfirmacao || !identificador.trim()"
            @click="confirmarPresenca"
          >
            <span v-if="enviandoConfirmacao"><i class="fa fa-spinner fa-spin mr-1"></i>Verificando...</span>
            <span v-else><i class="fa fa-check mr-1"></i>Confirmar Presença</span>
          </button>
        </div>
      </div>

      <!-- Rodapé -->
      <p class="text-center text-muted small mt-4">
        <i class="fa fa-leaf mr-1 text-success"></i>
        Plano Municipal de Arborização Urbana
      </p>

    </div>
  </div>
</template>

<script>
import PublicHearingService from "../../servico/PublicHearingService";

export default {
  name: "PublicHearingConfirmacao",
  data() {
    return {
      loading: true,
      evento: null,

      identificador: "",
      erroConfirmacao: "",
      enviandoConfirmacao: false,
      confirmacaoFeita: false,
      confirmacaoJaFeita: false,
      confirmacaoDados: null
    };
  },
  computed: {
    token() {
      return this.$route.params.token;
    },
    isHojeEvento() {
      if (!this.evento) return false;
      const evDate = new Date(this.evento.event_date);
      const today = new Date();
      return evDate.getFullYear() === today.getFullYear() &&
        evDate.getMonth() === today.getMonth() &&
        evDate.getDate() === today.getDate();
    }
  },
  beforeMount() {
    this.carregarEvento();
  },
  methods: {
    carregarEvento() {
      PublicHearingService.GetPublicEvent(this.token)
        .then((r) => { this.evento = r.data; })
        .catch(() => { this.evento = null; })
        .finally(() => { this.loading = false; });
    },

    confirmarPresenca() {
      if (!this.identificador.trim()) return;
      this.erroConfirmacao = "";
      this.enviandoConfirmacao = true;
      PublicHearingService.Confirm(this.token, this.identificador.trim())
        .then((r) => {
          this.confirmacaoDados = r.data.registration;
          this.confirmacaoJaFeita = r.data.already_confirmed;
          this.confirmacaoFeita = true;
        })
        .catch((e) => {
          this.erroConfirmacao =
            e?.response?.data?.detail || "Não encontrado. Verifique os dados ou faça sua inscrição.";
        })
        .finally(() => { this.enviandoConfirmacao = false; });
    },

    formatarData(iso) {
      if (!iso) return "";
      return new Date(iso).toLocaleDateString("pt-BR", {
        weekday: "long", day: "2-digit", month: "long", year: "numeric",
        hour: "2-digit", minute: "2-digit"
      });
    },
    formatarDataSimples(iso) {
      if (!iso) return "";
      return new Date(iso).toLocaleDateString("pt-BR", {
        weekday: "long", day: "2-digit", month: "long", year: "numeric"
      });
    }
  }
};
</script>

<style scoped>
.public-hearing-page {
  min-height: 100vh;
  background: #f5f5f5;
}
.public-hearing-container {
  max-width: 600px;
}
.public-hearing-header {
  background: linear-gradient(135deg, #1B5E20 0%, #2E7D32 60%, #388E3C 100%);
}
.public-hearing-header .opacity-75 {
  opacity: 0.85;
}
</style>
